import { useQuery } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

type FilteredTaskProps = Record<string, boolean | string | number>

export const useTasksByOrgId = (
  orgId: string | null,
  filters: FilteredTaskProps = {} // 👈 make filters optional with a default
) => {
  return useQuery({
    queryKey: ['tasksByOrgId', orgId, filters],
    queryFn: async () => {
      if (!orgId) return []
      const hasFilters = filters && Object.keys(filters).length > 0
      const params = hasFilters ? { filters: JSON.stringify(filters) } : {}
      const { data } = await axios.get(`${baseUrl}/aws/tasks/${orgId}`, { params })
      return data || []
    },
    enabled: !!orgId,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  })
}
